import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import type {
  IProductGuideEquipment,
  IProductGuidesData,
  IProductGuidesResult,
} from '../model/productGuideList';

const productGuidesKey = (customerId?: string) => ['productGuides', customerId];

const productGuidesFn = ({ queryKey }: QueryFunctionContext<(string | number)[]>) =>
  apiClient.get(`${APP_API_URL_V2}fsd/customers/${queryKey[1]}/user-guides`);

const productGuidesSelect = ({ data }: AxiosResponse<IProductGuidesData>) => {
  const items: IProductGuideEquipment[] = data.data ?? [];

  const result: IProductGuidesResult = {
    otherEquipment: [],
    moteEquipment: [],
    batteries: [],
  };

  items.forEach((item) => {
    switch (item.equipmentType) {
      case 'mote_sm1_sm2_sm6':
      case 'mote_sm7':
        result.moteEquipment.push(item);
        break;

      case 'mote_batteries':
        result.batteries.push(item);
        break;

      default:
        result.otherEquipment.push(item);
        break;
    }
  });

  return result;
};

export const useProductGuidesQuery = (customerId?: string | number) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: productGuidesKey(customerId),
    queryFn: productGuidesFn,
    select: productGuidesSelect,
  });
};
